import { Component, Input } from "@angular/core";

@Component({
  selector: "app-fill-mask-svg",
  templateUrl: "./fill-mask.svg"
})
export class SvgFillMaskComponent { }


@Component({
  selector: "app-question-answering-svg",
  templateUrl: "./question-answering.svg"
})
export class SvgQuestionAnsweringComponent { }


@Component({
  selector: "app-summary-svg",
  templateUrl: "./summary.svg"
})
export class SvgSummaryComponent { }


@Component({
  selector: "app-text-classification-svg",
  templateUrl: "./text-classification.svg"
})
export class SvgTextClassificationComponent { }


@Component({
  selector: "app-table-qna-svg",
  templateUrl: "./table-question-answering.svg"
})
export class SvgTableQnAComponent { }


@Component({
  selector: "app-text-generation-svg",
  templateUrl: "./text-generation.svg"
})
export class SvgTextGenerationComponent { }


@Component({
  selector: "app-text2text-generation-svg",
  templateUrl: "./text2text-generation.svg"
})
export class SvgText2TextGenerationComponent { }


@Component({
  selector: "app-token-classification-svg",
  templateUrl: "./token-classification.svg"
})
export class SvgTokenClassificationComponent { }


@Component({
  selector: "app-translation-svg",
  templateUrl: "./translation.svg"
})
export class SvgTranslationComponent { }


@Component({
  selector: "app-zero-shot-class-svg",
  templateUrl: "./zero-shot-classification.svg"
})
export class SvgZeroShotClassComponent { }


@Component({
  selector: "app-img-segmentation-svg",
  templateUrl: "./img-segmentation.svg"
})
export class SvgImgSegmentationComponent { }


@Component({
  selector: "app-svg-selector",
  templateUrl: "./svg_selector.component.html"
})
export class SvgSelectorComponent {
  @Input()
  name: string;
}


@Component({
  selector: "app-svg-task-selector",
  templateUrl: "./svg_task_selector.component.html",
  styleUrls: ["./svg_task_selector.component.css"]
})
export class SvgTaskSelectorComponent {
  @Input()
  name: string;
}
